// AT PAY WALLET — Compact gradient card (button-like) that shows balance + shortcut to AT Wallet page
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

export default function ATPayCard({ label = 'AT Pay Wallet', to = '/wallets' }) {
  const [bal, setBal] = useState(null);
  useEffect(() => {
    let mounted = true;
    api.get('/avx/wallet/me').then((r) => { if (mounted) setBal(r.data?.wallet?.at_balance ?? null); }).catch(() => {});
    return () => { mounted = false; };
  }, []);
  return (
    <Link to={to} data-testid="at-pay-card" className="block rounded-2xl border-2 border-emerald-400/50 bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-500 text-black p-3 shadow-lg shadow-emerald-500/20 hover:scale-[1.01] transition">
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-widest font-black opacity-80">💳 {label}</div>
          <div className="text-lg font-black leading-tight truncate">{bal !== null ? `${Number(bal).toLocaleString('en-IN')} AT` : '— AT'}</div>
          <div className="text-[10px] opacity-80">Tap to open wallet · view history · transfer</div>
        </div>
        <div className="text-2xl">💰</div>
      </div>
    </Link>
  );
}
